import { Box, styled } from '@planne-software/uni/mui/material';
import { uni } from '@planne-software/uni/v2';

import { tabletBreakpoint } from '@src/common/utils/mediaQuery';
import { uniTypography } from '@src/fonts/typography/uniTypography';

import { cardPulse } from '../../styles/animations';
import { cashbackBrandAccent, cashbackWhatsappGreen } from '../../styles/colors';

const cashbackBlueDark = '#151659';
const cashbackBlueLight = '#0B54AC';

const cashbackCardGradient = `linear-gradient(104deg, ${cashbackBlueDark} 30.25%, ${cashbackBlueLight} 53.82%, ${cashbackBlueDark} 76.81%);`;

const accentGlow = (alpha: number) => `rgba(87, 227, 164, ${alpha})`;

export const GrowthCardRoot = styled(Box)`
  border-radius: ${uni('border-radius-xl')};
  background: ${cashbackCardGradient};
  padding: ${uni('scale-500')} ${uni('scale-600')};
  display: flex;
  align-items: center;
  gap: ${uni('scale-400')};
  position: relative;
  overflow: hidden;
  animation: ${cardPulse} 2.4s ease-in-out infinite;

  ${tabletBreakpoint} {
    flex-direction: column;
    align-items: stretch;
    padding: ${uni('scale-300')};
    gap: ${uni('scale-300')};
  }
`;

export const GrowthCardMessage = styled(Box)`
  display: contents;

  ${tabletBreakpoint} {
    display: flex;
    align-items: center;
    gap: ${uni('scale-300')};
    width: 100%;
    min-width: 0;
  }
`;

export const GrowthCardGlow = styled(Box)`
  position: absolute;
  right: -30px;
  top: -30px;
  width: 140px;
  height: 140px;
  border-radius: ${uni('border-radius-round')};
  background: radial-gradient(circle, ${accentGlow(0.15)} 0%, transparent 70%);
  pointer-events: none;
`;

export const GrowthCardIcon = styled(Box)`
  flex-shrink: 0;
  width: ${uni('scale-1100')};
  height: ${uni('scale-1100')};
  border-radius: ${uni('border-radius-round')};
  background: rgba(255, 255, 255, 0.1);
  border: 1.5px solid ${accentGlow(0.4)};
  color: ${cashbackBrandAccent};
  display: inline-flex;
  align-items: center;
  justify-content: center;

  ${tabletBreakpoint} {
    width: ${uni('scale-800')};
    height: ${uni('scale-800')};
  }
`;

export const GrowthCardText = styled('p')`
  flex: 1;
  min-width: 0;
  margin: 0;
  ${uniTypography('text-sm', 'semibold')}
  color: ${uni('neutral-white')};
  line-height: 1.5;

  strong {
    font-weight: ${uni('typography-font-weight-bold')};
    color: ${cashbackBrandAccent};
  }
`;

export const GrowthCardRedeemButton = styled('button')`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: ${uni('scale-150')};
  padding: ${uni('scale-300')} ${uni('scale-450')};
  border: 0;
  border-radius: ${uni('border-radius-xs')};
  background: ${cashbackWhatsappGreen};
  color: ${uni('neutral-white')};
  font-family: ${uni('font-family-text')};
  ${uniTypography('text-sm', 'semibold')}
  cursor: pointer;
  white-space: nowrap;

  ${tabletBreakpoint} {
    width: 100%;
    justify-content: center;
    padding: ${uni('scale-350')} ${uni('scale-450')};
  }
`;
